export default {
  global: {
    name: 'Name',
    email: 'Email',
    password: 'Password',
    tracking: 'Tracking | Trackings',
    request: 'Request | Requests',
    // dashboard: 'Dashboard',
    shipmentNumber: 'NUMBER OF SHIPMENTS',
    totalInvoiceCost: 'TOTAL INVOICE COST',
    freightCost: 'FREIGHT COSTS',
    accesorialCost: 'ACCESSORIES COSTS',
    taxesCost: 'TAX COSTS',
    fuelCost: 'FUEL COSTS',
    packages: 'PACKAGES',
    lbs: 'LBS',
    miles: 'MILES',
    value: 'DECLARED VALUE',
    transitTime: 'TRANSIT TIME',
    loadHours: 'LOADING HOURS',
    unloadHours: 'UNLOADING HOURS',
    origin: 'Origin',
    destination: 'Destination',
    updated: 'Updated',
    client_id: 'Client ID',
    national: 'National',
    international: 'International',
    company: 'Company',
    metric: 'Metric',
    english: 'English',
    weight: 'Weight',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    description: 'Description',
    priority: 'Priority',
    notes: 'Notes',
    country: 'Country',
    comment: 'Comment | Comments',
    package: 'Package | Packages',
    dimensions: 'Dimensions',
    price: 'Price',
    add: 'Add',
    menu: 'Menu',
    device: 'Device | Devices',
    logout: 'Logout',
    cancel: 'Cancel',
    connect: 'Connect',
    rename: 'Rename',
    remove: 'Remove',
    save: 'Save',
    status: 'Status',
    date: 'Date',
    detail: 'Detail',
    routes: 'Routes',
    departure_date: 'Departure date',
    driver: 'Driver',
    in_progress: 'In progress',
    completed: 'Completed',
    distance_traveled: 'Distance traveled',
    no_routes: 'No routes have been registered.',
    intersection: 'Intersection {label}',
    activity: 'Activity',
    document: 'Document | Documents',
    internal: 'Internal',
    emergency: 'Emergency',
    photo: 'Photo | Photos',
    audio: 'Audio | Audios',
    home: 'Home',
    notification: 'Notification | Notifications',
    accept: 'Accept',
    language: 'Language',
    close: 'Close',
    requested_by: 'Requested by',
    customer: 'Customer',
    type: 'Type',
    direct: 'Direct',
    trailer: 'Trailer',
    commodities: 'Commodities',
    importation: 'Import',
    quantity: 'Quantity',
    code: 'Code',
    no_results: 'No results',
    message_no_results: 'No results found with those search filters.',
    lbl_country: 'Country'
  },
  resetPassword: {
    title: 'Create a new password',
    description:
      'Your new password must be different from any password you have used before.',
    lblBtn: 'Change password',
    messageNullToken: 'There is no token to reset your password.'
  },
  dashboard: {
    title: 'Dashboard',
    info: 'The information was calculated based on the recorded data. For more accurate results, please complete all relevant fields.',
    search: 'Search',
    filters: {
      title: 'Filters',
      project: 'Projects',
      client: 'Client',
      platforms: 'Platform',
      date: 'Date',
      period: 'Period',
      select: 'Select',
      showResults: 'Show results',
      cleanFilters: 'Clean filters'
    },
    freightData: {
      title: 'Additional information',
      shipmentNumber: 'SHIPMENT NUMBER',
      totalInvoiceCost: 'TOTAL INVOICE COST',
      freightCost: 'FREIGHT COST',
      accesorialCost: 'ACCESORIAL COST',
      taxesCost: 'TAXES COST',
      fuelCost: 'FUEL COST',
      packages: 'PACKAGES',
      lbs: 'LBS',
      weigth: 'WEIGTH',
      miles: 'MILES',
      value: 'DECLARED VALUE',
      transitTime: 'TRANSIT TIME',
      loadHours: 'LOAD HOURS',
      unloadHours: 'UNLOAD HOURS',
      totalTransitTime: 'TRANSIT TIME',
      averageTransitTime: 'AVERAGE TRANSIT TIME',
      minimumTransitTime: 'MINIMUM TRANSIT TIME',
      maximumTransitTime: 'MAXIMUM TRANSIT TIME',
      totalLoadHours: 'LOAD HOURS',
      averageLoadHours: 'AVERAGE LOAD HOURS',
      minimumLoadHours: 'MINIMUM LOAD HOURS',
      maximumLoadHours: 'MAXIMUM LOAD HOURS',
      totalUnloadHours: 'UNLOAD HOURS',
      averageUnloadHours: 'AVERAGE UNLOAD HOURS',
      minimumUnloadHours: 'MINIMUM UNLOAD HOURS',
      maximumUnloadHours: 'MAXIMUM UNLOAD HOURS',
      minimumTime: 'Minimum time',
      maximumTime: 'Maximum time'
    }
  },
  menu: {
    lbl_scan: 'Scan QR',
    lbl_account: 'My Account',
    lbl_unit_request: 'Unit request'
  },
  account: {
    lbl_type: 'User Type',
    lbl_date: 'Registration Date',
    msg_user:
      'If you want to update your contact information, you need to contact your tracking agent directly',
    btn_pass: 'Change Password',
    msg_pass:
      'The password must be at least six characters long and include a combination of numbers and uppercase letters.',
    pdr_newpass: 'New Password',
    btn_change: 'Change Password',
    msg_change_pass: 'Your password was successfully changed.',
    lbl_language: 'Select your language',
    btn_language: 'Change language'
  },
  auth: {
    login: {
      forgot_link: 'Forgot my password',
      login_btn: 'Login',
      forgot_title: 'Reset Password',
      forgot_description:
        'Enter your email address associated with your account and we will send you a link to reset your password.',
      forgot_input: 'Enter your email',
      forgot_btn: 'Send Password Link',
      msg_recovery:
        'We have successfully sent an email to your account to recover your password.'
    }
  },
  home: {
    welcome_back: 'Welcome back',
    lbl_tracking: 'Total trackings from last week',
    lbl_requests: 'Total requests from last week',
    title_tracking: 'Latest Trackings',
    title_requests: 'Latest Requests',
    list_btn: 'View All'
  },
  request: {
    priority: {
      normal: 'Normal',
      urgent: 'Urgent',
      critical: 'Critical'
    },
    status: {
      pending: 'Pending',
      quoted: 'Quoted',
      accepted: 'Accepted',
      refused: 'Refused'
    },
    pdr_search: 'Search by ID',
    btn_create: 'Create Request',
    filter: {
      title: 'Filter by',
      lbl_request: 'Request Type',
      lbl_unit: 'Unit Type',
      lbl_priority: 'Urgency Level',
      lbl_date: 'Date',
      this_week: 'This Week',
      last_week: 'Last Week',
      this_month: 'This Month',
      last_month: 'Last Month',
      custom: 'Custom',
      btn_result: 'View Results',
      btn_clean: 'Clear Filters'
    },
    create: {
      lbl_vehicle: 'Type of vehicle',
      lbl_shipper_ref: 'Shipper Ref',
      lbl_loading_date: 'Loading Date',
      lbl_description_goods: 'Description of goods',
      lbl_unit_measurement: 'Unit of Measurement',
      lbl_unit_weight_lbs: 'Weight Lbs',
      opt_domestic_usa: 'DOMESTIC USA',
      pdr_service: 'Service Type',
      pdr_date: 'Pick-up Date',
      pdr_zipcode: 'Zip Code',
      pdr_address: 'Enter the Address',
      pdr_origin: 'Origin City',
      pdr_destination: 'Destination City',
      pdr_state: 'State',
      lbl_weight: 'Dimensions and Weight',
      lbl_number: 'Number of Packages',
      btn_create: 'Create Request',
      msg_create: 'The request was successfully created.'
    },
    detail: {
      lbl_quote: 'Detail and Quote',
      lbl_update: 'Last Update',
      btn_add: 'Add Quote',
      btn_comment: 'Comment',
      pdr_comment: 'Enter your comment',
      btn_quote: 'Upload Quote',
      btn_accept: 'Accept Quote',
      btn_refuse: 'Refuse Quote',
      lbl_comment: 'No comments',
      empty_comment:
        'Comments for this request will appear in this section, you can create a comment at the bottom.',
      msg_quote_add: 'The quote has been successfully added.',
      msg_notes: 'Your comment was successfully created.',
      msg_refuse: 'The quote was refused.',
      msg_accept: 'The quote was accepted.',
      lbl_origin: 'Origin',
      lbl_destination: 'Destination',
      lbl_intermediatePoint: 'Intermediate point',
      lbl_endPoint: 'End point',
      lbl_cameOut: 'Came out',
      lbl_route: 'Route',
      lbl_arrive: 'Arrive',
      lbl_on: 'el',
      lbl_status_inProgress: 'In progress',
      lbl_status_pending: 'Pending',
      lbl_status_filled: 'Filled',
      lbl_unit: 'Unit',
      lbl_lastUpdate: 'Last location',
      lbl_locationShared: 'location shared by the driver',
      lbl_btn_forwardLink: 'Forward link',
      lbl_btn_call: 'Call',
      lbl_btn_assignADriver: 'Assign a driver and share',
      lbl_btn_noDriverAssigned: 'No driver assigned',
      lbl_incompleteInformation: 'Incomplete information',
      status: {
        lbl_group_in_preparation: 'In preparation',
        lbl_invited: 'Invited',
        lbl_invited_description:
          'The link was sent to the driver; he hasn`t opened it yet.',
        lbl_ready: 'Ready to head out',
        lbl_ready_description:
          'The driver accepted and shared his location; he has not yet left the starting point.',
        lbl_group_in_transit: 'In transit',
        lbl_en_route: 'In route',
        lbl_en_route_description:
          'It departed from the origin and is moving toward the destination.',
        lbl_near_dest: 'Near the destination',
        lbl_ready_description:
          'Entered the arrival radius for the destination (e.g., 10 km).',
        lbl_group_detained_in_transit: 'Traffic at a standstill',
        lbl_break_detected: 'Break detected',
        lbl_break_detected_description:
          'The system detects the vehicle at a standstill with no recorded rest period.',
        lbl_on_break: 'On break',
        lbl_on_break_description:
          'The driver logged a rest period; a scheduled stop.',
        lbl_group_at_destination: 'At destination',
        lbl_at_dest: 'At destination',
        lbl_at_dest_description: 'He arrived at the destination facilities.',
        lbl_at_ramp: 'On an incline',
        lbl_at_ramp_description:
          'Assigned to ramp/loading dock, awaiting unloading.',
        lbl_delivering: 'Delivering',
        lbl_delivering_description: 'Unloading or delivery in progress.',
        lbl_awaiting_instructions: 'Awaiting instructions',
        lbl_awaiting_instructions_description:
          'The driver awaits an instruction from the operator to continue.',
        lbl_group_closing: 'Closing',
        lbl_pod_pending: 'POD pending',
        lbl_pod_pending_description:
          'Delivered; proof of delivery (signature / photo) is missing.',
        lbl_completed: 'Completed',
        lbl_completed_description:
          'Delivered with POD; location sharing has stopped.'
      }
    }
  },
  devices: {
    msg_device:
      'This is the linked devices section, from here you can manage which devices have access to Grupo Proexi information, as well as edit, delete, or add new devices',
    pdr_search: 'Search devices',
    btn_device: 'Connect New Device',
    msg_code: 'To log in, confirm that the following code matches this screen:',
    msg_qr:
      'If the code does not match, press cancel and scan the QR code on your screen again.',
    title_edit: 'Edit Device',
    lbl_dark: 'Enable Dark Mode',
    msg_dark:
      'Choose whether to enable dark mode when viewing the application on connected screens',
    msg_remove: 'The device was successfully deleted.',
    title_edit: 'Edit Name',
    msg_edit: 'Assign a name to identify this device',
    title_delete: 'Delete Device',
    msg_delete:
      'Are you sure you want to delete this device? If you proceed, you will no longer be able to view the information on your screen and will need to link the application again.',
    btn_delete: 'Delete Device',
    msg_device_pair: 'The device was successfully connected.',
    msg_invalid_link: 'The link is invalid.',
    title_assign_name: 'Assign name',
    caption_assign_name: 'Assign a name to identify this device',
    lbl_device_name: 'Device name',
    lbl_device_type: 'Device type',
    lbl_device_location: 'Device location'
  },
  tracking: {
    pdr_search: 'Search by PLO or Client ID',
    lbl_date: 'Departure Date',
    lbl_truck: 'Truck/Box Number',
    last_update: 'Last Update',
    add_notes: 'Add Notes',
    msg_remove: 'Are you sure you want to proceed with this action?',
    title_empty_updates: 'No Activity Updates',
    msg_empty_updates:
      'Updates for this tracking will appear in this section. To create a new update record, click the button below.',
    title_empty_docs: 'No Documents',
    msg_empty_docs: 'Documents for this reference will appear on this section.',
    btn_add_doc: 'Add Document',
    btn_add_files: 'Add Files',
    msg_loc: 'Please allow the application to access your location.',
    btn_doc: 'Upload Document',
    btn_share: 'Share PLO',
    btn_shareRoute: 'Share route',
    btn_resend_invitation: 'Resend invitation',
    btn_share_access: 'Share Access',
    btn_copy_access: 'Copy Access',
    msg_notes: 'Your notes have been successfully added.',
    msg_remove_notes: 'Your notes have been successfully deleted.',
    msg_share_plo1:
      "We've shared the access link to track your order using the reference number:",
    msg_share_plo2: 'You can find it at the following link:',
    msg_copy_link: 'The link has been copied successfully',
    msg_copy_link_error: 'Unable to share the link',
    lbl_transit_time: 'Transit time',
    lbl_logistics_operator: 'Logistics Operator',
    lbl_phone_number: 'Phone number',
    lbl_copy_share:
      'Enter the phone number of the driver who will track the trip.',
    btn_send_access: 'Send access',
    lbl_message_share_route:
      'We are providing you with access to track the status via the following link:',
    update: {
      title_update: 'Add Update',
      lbl_type: 'Update Type',
      pdr_detail: 'Update Detail',
      pdr_notes: 'Update Notes',
      btn_create: 'Create Update',
      lbl_photo: 'Upload Photos',
      lbl_doc: 'Upload Documents',
      lbl_audio: 'Record Audio',
      lbl_audio_2: 'Re-record Audio',
      lbl_record: 'Record a Voice Note',
      msg_create: 'The update was successfully created.'
    }
  },
  notifications: {
    title: 'No notifications',
    caption:
      'In this section, notifications about activity, status changes, and requests will appear.'
  },
  errors: {
    err_geolocation_service:
      'Location service is turned off. Please enable the location service on your device to continue.',
    err_mic: 'Error accessing microphone:',
    err_loc: 'Unable to obtain your location.',
    err_default: 'An unknown error occurred while making the server request.',
    err_503: {
      slam: 'Sorry, the SLAM platform encountered an issue saving the update.',
      areelec:
        'Sorry, the AREELEC database encountered an issue saving the update.'
    },
    err_401: {
      default: 'You must be authenticated to access this resource.',
      token:
        'Your session was used on another device and has been deactivated. Please log in again to access the platform.',
      credentials: 'Incorrect username and/or password.'
    },
    err_404: {
      default: 'The resource was not found on the server.',
      order: 'The order does not exist.',
      gps: 'No GPS information available.'
    },
    err_422: {
      order: 'You already have a created order.',
      session: 'Registration time has expired.',
      unauthorized: 'You are not authorized to perform this action.',
      invalid_session: 'The current session does not exist or is invalid.',
      invalid_token:
        'The code is not valid, please verify that your code is correct.',
      invalid_slam_status:
        'Sorry, the SLAM platform does not have the provided status for updating.',
      invalid_areelec_status:
        'Sorry, the AREELEC database does not have the provided status for updating.',
      invalid_extension_file: 'Sorry, the file extension is not valid.',
      100: {
        email: 'The email is already registered.'
      }
    }
  },
  rules: {
    required: 'The field is required',
    min: 'The value must be greater than or equal to {min}',
    max: 'The value must be less than or equal to {max}',
    minLength: 'The value must have at least {min} characters',
    maxLength: 'The value must have a maximum of {max} characters',
    hasSpecialChar: 'The field must contain at least one special character',
    hasUpper: 'The field must contain at least one uppercase letter',
    hasLower: 'The field must contain at least one lowercase letter',
    hasNumber: 'The field must contain at least one number',
    pattern:
      'The password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character (#?!@$%^&*-).'
  }
}
